var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDermiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.18,999.02h488.38c212.89,0,385.46-172.58,385.46-385.46V386.44c0-212.89-172.58-385.46-385.46-385.46H125.18 c-68.6,0-124.2,55.61-124.2,124.2v749.63C0.98,943.41,56.59,999.02,125.18,999.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.84,811.89h305.23c133.05,0,240.91-107.86,240.91-240.91V429.03c0-133.05-107.86-240.91-240.91-240.91 H253.84c-42.87,0-77.63,34.76-77.63,77.63v468.52C176.21,777.13,210.97,811.89,253.84,811.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.54,687.13h183.14c79.83,0,144.55-64.72,144.55-144.55v-85.17c0-79.83-64.72-144.55-144.55-144.55H347.54 c-25.72,0-46.58,20.85-46.58,46.58v281.11C300.97,666.28,321.82,687.13,347.54,687.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.53,500h61.05c26.61,0,48.18-21.57,48.18-48.18v-28.39c0-26.61-21.57-48.18-48.18-48.18h-61.05 c-8.57,0-15.53,6.95-15.53,15.53v93.7C500,493.05,506.95,500,515.53,500z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDermiLogo);
export default __webpack_public_path__ + "static/media/dermi_logo.8383948d6b85f00948cbfabba9a5e740.svg";
export { ForwardRef as ReactComponent };